import { FC, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Popover } from "antd";
import { Icon } from "Components/UI";
import { ButtonMoreActions, Card, CardItem, Container, Hr } from "./styles";

interface IMoreActionsDropdownProps {
  iconColor?: string;
  hasDeletePermission?: boolean;
  isActivityPage?: boolean;
  onDelete: () => void;
  onCopyLink: () => void;
  onDuplicate?: () => void;
}

const MoreActionDropdown: FC<IMoreActionsDropdownProps> = ({
  iconColor,
  hasDeletePermission,
  isActivityPage,
  onDelete,
  onCopyLink,
  onDuplicate,
}) => {
  const { t } = useTranslation('activities');
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleCopyLink = () => {
    onCopyLink();
    hide();
  };

  const handleDuplicate = () => {
    onDuplicate && onDuplicate();
    hide();
  };

  const handleDelete = () => {
    onDelete();
    hide();
  };

  const overlay = (
    <Container>
      <Card>
        <CardItem onClick={handleCopyLink}>
          <Icon icon="link" className="cardItemIcon" />
          <span className="cardItemText">
            {t('moreActions.copyLink')}
          </span>
        </CardItem>
        {isActivityPage && (
          <CardItem onClick={handleDuplicate}>
            <Icon icon="copiar" customSize={16} className="cardItemIcon" />
            <span className="cardItemText">
              {t('moreActions.duplicate')}
            </span>
          </CardItem>
        )}
      </Card>
      {hasDeletePermission && (
        <>
          <Hr />
          <Card>
            <CardItem
              isdelete={true}
              onClick={handleDelete}
            >
              <Icon icon="excluir" className="cardItemIcon" />
              <span className="cardItemText">
                {t('moreActions.delete')}
              </span>
            </CardItem>
          </Card>
        </>
      )}
    </Container>
  )

  return (
    <Popover
      content={overlay}
      placement="bottomRight"
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      overlayInnerStyle={{ padding: 0 }}
    >
      <ButtonMoreActions>
        <Icon
          icon="moreActions"
          customSize={16}
          customColor={iconColor ? iconColor : '#324150'}
        />
      </ButtonMoreActions>
    </Popover>
  )
}

export default MoreActionDropdown;
